export enum TextMode {
  Html = 'html',
  Text = 'text',
}
